<!-- 搜索组件 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb-0">
            <Menu mode="horizontal" :active-name="name_id" @on-select="selectName">
                <MenuItem name="1">内容设置</MenuItem>
                <MenuItem name="2">边距设置</MenuItem>
            </Menu>
            <div class="mt-24">
                <div v-if="name_id == 1">
                    <Form :model="newFormData.content" label-position="right" :label-width="100">
                        <div class="form-title">搜索框设置</div>
                        <FormItem label="搜索框高">
                            <Input v-model="newFormData.content.height" placeholder="请输入搜索框高"><span slot="append">PX</span></Input>
                        </FormItem>
                        <FormItem label="圆角">
                            <Input v-model="newFormData.content.header.radius" placeholder="请输入圆角"><span slot="append">PX</span></Input>
                        </FormItem>
                        <FormItem label="提示文字">
                            <Input v-model="newFormData.content.text" placeholder="请输入提示文字"></Input>
                        </FormItem>
                        <FormItem label="文字位置">
                            <RadioGroup v-model="newFormData.content.position" type="button">
                                <Radio label="left" ><Icon type="md-menu" /></Radio>
                                <Radio label="center" ><Icon type="md-funnel" /></Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="文字颜色">
                            <ColorPicker v-model="newFormData.content.text_color" />
                        </FormItem>
                        <FormItem label="搜索框背景">
                            <ColorPicker v-model="newFormData.content.search_color" />
                        </FormItem>
                        <FormItem label="搜索框边框">
                            <ColorPicker v-model="newFormData.content.border_color" />
                        </FormItem>
                        <FormItem label="按钮背景">
                            <ColorPicker v-model="newFormData.content.bgs_color" />
                        </FormItem>
                        <FormItem label="上传图标">
                            <div class="form-upload position_relative" @click="openModal">
                                <Icon v-if="newFormData.content.imgs.picview" class="form_icon" size="20" type="ios-close-circle" color="#f00" @click.stop="delImg"/>
                                <img v-if="newFormData.content.imgs.picview" class="form-img" :style="`background-color: ${newFormData.content.bgs_color};`" :src="newFormData.content.imgs.picview" />
                                <Icon v-else type="md-add" size="30" color="#ccc"/>
                            </div>
                        </FormItem>
                        <div class="form-title">按钮设置</div>
                        <FormItem label="选择样式">
                            <RadioGroup v-model="newFormData.content.style_value" >
                                <Radio class="mr-24" label="1">按钮样式</Radio>
                                <Radio class="mr-24" label="2">图片样式</Radio>
                            </RadioGroup>
                        </FormItem>
                        <template v-if="newFormData.content.style_value == 1">
                            <FormItem label="上间距">
                                <Input v-model="newFormData.content.search_mt" placeholder="请输入上间距" ><span slot="append">PX</span></Input>
                            </FormItem>
                            <FormItem label="按钮框高">
                                <Input v-model="newFormData.content.btn_height" placeholder="请输入按钮框高" ><span slot="append">PX</span></Input>
                            </FormItem>
                            <FormItem label="圆角">
                                <Input v-model="newFormData.content.footer.radius" placeholder="请输入圆角" ><span slot="append">PX</span></Input>
                            </FormItem>
                            <FormItem label="按钮文字">
                                <Input v-model="newFormData.content.btn_text" placeholder="请输入按钮文字" ></Input>
                            </FormItem>
                            <FormItem label="按钮背景">
                                <ColorPicker v-model="newFormData.content.btn_bg_color" />
                            </FormItem>
                            <FormItem label="按钮边框">
                                <ColorPicker v-model="newFormData.content.btn_border_color" />
                            </FormItem>
                        </template>
                        <template v-else-if="newFormData.content.style_value == 2">
                            <FormItem label="上间距">
                                <Input v-model="newFormData.content.search_mt" placeholder="请输入上间距" ><span slot="append">PX</span></Input>
                            </FormItem>
                            <FormItem label="上传图片">
                                <div class="form-upload position_relative" @click="openModal('search_img')">
                                    <Icon v-if="newFormData.content.search_img.picview" class="form_icon" size="20" type="ios-close-circle" color="#f00" @click.stop="delImg('search_img')"/>
                                    <img v-if="newFormData.content.search_img.picview" class="form-img" :src="newFormData.content.search_img.picview" />
                                    <Icon v-else type="md-add" size="30" color="#ccc"/>
                                </div>
                            </FormItem>
                        </template>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色">
                            <ColorPicker v-model="newFormData.content.bg_color" />
                        </FormItem>
                        <FormItem label="背景图">
                            <i-switch v-model="newFormData.content.bg_value" size="large" true-color="#FF761D" :true-value="1" :false-value="0" @on-change="changeBgValue">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem v-if="newFormData.content.bg_value" label="上传背景">
                            <div class="bg-upload" @click="openModal('bg_img')">
                                <img class="bg-img" v-if="newFormData.content.bg_img.picview" :src="newFormData.content.bg_img.picview"/>
                                <Icon v-else type="md-add" size="30" color="#ccc"/>
                            </div>
                        </FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form :model="newFormData" label-position="right" :label-width="80">
                        <div class="form-title">外间距</div>
                        <FormItem label="上下间距"><Slider v-if="newFormData.content.marginData" class="w300" show-input v-model="newFormData.content.marginData.top"></Slider></FormItem>
                        <FormItem label="左右间距"><Slider v-if="newFormData.content.marginData" class="w300" show-input v-model="newFormData.content.marginData.left"></Slider></FormItem>
                        <div class="form-title">内间距</div>
                        <FormItem label="上下间距"><Slider v-if="newFormData.content.paddingData" class="w300" show-input v-model="newFormData.content.paddingData.top"></Slider></FormItem>
                        <FormItem label="左右间距"><Slider v-if="newFormData.content.paddingData" class="w300" show-input v-model="newFormData.content.paddingData.left"></Slider></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"><Slider v-if="newFormData.content.radiusData" class="w300" show-input v-model=" newFormData.content.radiusData.top"></Slider></FormItem>
                        <FormItem label="下圆角"><Slider v-if="newFormData.content.radiusData" class="w300" show-input v-model=" newFormData.content.radiusData.bottom"></Slider></FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary 
            v-if="switch_modal" 
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>    
    </div>
</template>

<script>
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            srctype: "",
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
        };
    },
    mounted() {},
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if(this.srctype == 'bg_img'){
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.bg_img.picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.bg_img.value = param2[i];
                }
            }else if (this.srctype == 'search_img'){
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.search_img.picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.search_img.value = param2[i];
                }
            }else{
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.imgs.picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.imgs.value = param2[i];
                }
            }
            this.$Message.destroy();
        },
        openModal(index) {
            this.switch_modal = true;
            this.srctype = index;
        },
        changeBgValue(e) {
            this.newFormData.content.bgValue = e;
        },
        selectName(name) {
            this.name_id = name;
        },
        delImg(e){
            if(e == 'search_img'){
                this.newFormData.content.search_img.picview = ''
                this.newFormData.content.search_img.value = ''
            }else{
                this.newFormData.content.imgs.picview = ''
                this.newFormData.content.imgs.value = ''
            }
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 4px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.form-upload {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    background: #ffffff;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
}
.form-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
/* RadioGroup */
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #fff;
    border-color: #ff761d;
    color: #ff761d;
    box-shadow: -1px 0 0 0 #ff761d;
}
::v-deep .ivu-radio-group-button :hover {
    color: #ff761d;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
.position_relative {
    position: relative;
}
.form_icon {
    position: absolute;
    top: -10px;
    right: -10px;
}
</style>